var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.characteristics.length === 0
        ? _c("span", [_vm._v(_vm._s(_vm.emptyText))])
        : _vm._l(_vm.preparedCharacteristics, function(characteristic, i) {
            return _c(
              "span",
              { key: characteristic.id + "-" + i },
              [
                i > 0 ? _c("span", [_vm._v(" | ")]) : _vm._e(),
                _vm._v(" "),
                _c("Label", {
                  attrs: {
                    characteristic: characteristic,
                    "label-type": _vm.labelType
                  }
                })
              ],
              1
            )
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }